import React, { ReactNode } from 'react';
import Button from 'app/components/Button/base';

const PrimaryButton = ({
  label,
  onClick,
  disabled,
  className,
}: {
  label: string | ReactNode;
  onClick: (e) => void;
  disabled?: boolean;
  className?: string;
}) => (
  <Button
    label={label}
    onClick={onClick}
    disabled={disabled}
    className={`px-4 py-2  ${className ? className : ''} ${
      disabled ? 'bg-slate-600' : 'bg-slate-900 '
    } inline-flex items-center text-sm hover:bg-slate-800 justify-center howio-font-md rounded-lg `}
  ></Button>
);

export default PrimaryButton;
